import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import IconButton from '@mui/material/IconButton';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';

import { CardWrapper } from 'globalStyles';
import { CardHeader, CardTitle, CardTitleWrapper } from './CampaignReportsTopCard.styles';

const CampaignReportsTopCard = ({ backButtonLink, title }) => {
  const history = useHistory();

  return (
    <CardWrapper>
      <CardHeader>
        <CardTitleWrapper>
          {backButtonLink && (
            <IconButton aria-label="go back" onClick={() => history.push(backButtonLink)}>
              <ArrowBackIcon />
            </IconButton>
          )}
          <CardTitle>{title}</CardTitle>
        </CardTitleWrapper>
      </CardHeader>
    </CardWrapper>
  );
};

CampaignReportsTopCard.propTypes = {
  backButtonLink: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default CampaignReportsTopCard;
